module.exports = __webpack_public_path__ + "img/yellow.0d6e452d.jpg";